import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const NewExtensionSubscriptionModalParts = [
  'bodyContainer',
  'dropdownContainer',
  'dropdownLabel',
  'itemContainer',
  'itemText',
  'footerContainer',
] as const

const helpers = createMultiStyleConfigHelpers(
  NewExtensionSubscriptionModalParts,
)
export const NewExtensionSubscriptionModalStyle =
  helpers.defineMultiStyleConfig({
    baseStyle: {
      bodyContainer: {
        flexDirection: 'column',
        paddingY: '0.25rem',
        paddingX: '1rem',
        gap: '1.5rem',
      },
      dropdownContainer: {
        flexDirection: 'column',
        gap: '0.25rem',
      },
      dropdownLabel: {
        ...textStyles[textStyleKeys.Body4_Bold],
      },
      itemContainer: {
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 'full',
        paddingX: '0.75rem',
        paddingY: '0.5rem',
        gap: '0.5rem',
      },
      itemText: {
        ...textStyles[textStyleKeys.Body1],
      },
      footerContainer: {
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: '0.62rem',
      },
    },
  })

export const useNewExtensionSubscriptionModalStyle = (
  props?: StyleThemingProps,
) => {
  return mergeMultiStyleConfig(
    NewExtensionSubscriptionModalStyle,
    props,
  ) as MultiStyleType<typeof NewExtensionSubscriptionModalParts>
}
